<template>
  <donut-chart08-template :board-ids="[242]" :data-type="dataType" field-code="facility-public" :graph-id="63" :title="title" unit="건" />
</template>

<script>
/* eslint-disable brace-style */
import DonutChart08Template from "@/views/graph/DonutChart08Template.vue";

export default {
  name: "DonutChart63",
  components: { DonutChart08Template },
  props: {
    dataType: "detail" | "field" | "company" | "project",
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    title() {
      const projectId = Number(this.projectId);
      if (projectId === 5) return "(공중(다중)이용시설) 비상조치계획수립 현황";
      else return "(다중(공중)이용시설) 비상조치계획수립 현황";
    },
  },
};
</script>

<style scoped></style>
